const jwt = require('jsonwebtoken');
const axios = require('axios');
const Cookies = require('js-cookie');

function decodeUser(idToken) {
    const decoded = jwt.decode(idToken);
    const keys = ['custom:ccid', 'custom:displayName', 'family_name'];
    if (!keys.every(k => !!decoded[k])) {
        const missing = keys.filter(cur => !decoded[cur]);
        throw Error(`Required key not found in id_token ${missing.join(',')}`);
    }
    return {
        ccid: decoded['custom:ccid'],
        name_ccid: `${decoded['custom:displayName']} ${
            decoded.family_name
        } (${decoded['custom:ccid']})`,
    };
}

function removeAlphanumericIndex(text) {
    const prefix = /^[A-Za-z]?([0-9]+)?\.?\)?\s/;
    let clean = text.replace(prefix, '');
    return clean;
}

function autoGenerateExam(exam) {
    const LOOKING_FOR_QUESTION = 0;
    const LOOKING_FOR_ANSWERS = 1;

    let alpha = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p",
        "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
    let context = {
        state: LOOKING_FOR_QUESTION,
        currentQuestion: 1,
        currentAnswer: 0
    }

    let question = {
        pre: [],
        post: [],
        type: '',
        text: '',
        answers: [],
        tokens:[]
    }

    let exam_final = {
        questions: []
    };

    for (let i = 0; i < exam.length; i++) {
        let percentValue = 0;
        // If a potentially correct answer, set percentValue to 100 and remove first * from string. 
        const firstFiveChars = exam[i].value.substring(0, 5);
        if (firstFiveChars.indexOf('*') > -1) {
            percentValue = 100;
            exam[i].value = exam[i].value.replace('*', ''); 
        }

        // Look for question is in question state.
        if (context.state === LOOKING_FOR_QUESTION) {
            if (exam[i].value.startsWith(context.currentQuestion + '. ') ||
                exam[i].value.startsWith(context.currentQuestion + ') ')) {
                context.currentQuestion++;
                question.text = removeAlphanumericIndex(exam[i].value);
                exam[i].active = false;
                question.tokens.push(exam[i].index);
                context.state = LOOKING_FOR_ANSWERS;
            }
            else {
                question.pre.push(exam[i].value);
                exam[i].active = false;
                question.tokens.push(exam[i].index);
            }
        }
        else if (context.state === LOOKING_FOR_ANSWERS) {
            if (exam[i].value.startsWith(context.currentQuestion + '. ') ||
                exam[i].value.startsWith(context.currentQuestion + ') ')) {
                // Wrap up last question.
                // Type?
                if (question.answers.length === 0) {
                    question.type = 'shortanswer';
                }
                else if (question.answers.length === 2 && 
                         ( (question.answers[0].text.toLowerCase() === 'true' && question.answers[1].text.toLowerCase() === 'false') ||
                           (question.answers[0].text.toLowerCase() === 'false' && question.answers[1].text.toLowerCase() === 'true') )) {
                    question.type = 'truefalse';
                }
                else {
                    question.type = 'multichoice';
                }
                exam_final.questions.push(question);
                // reset
                context.currentAnswer = 0;
                question = {
                    selected: "#1e1e1e",
                    pre: [],
                    post: [],
                    type: '',
                    text: removeAlphanumericIndex(exam[i].value),
                    answers: [],
                    tokens: []
                }
                exam[i].active = false;
                question.tokens.push(exam[i].index);
                context.currentQuestion++;
            }
            else if (exam[i].value.toLowerCase().startsWith(alpha[context.currentAnswer] + '. ') ||
                exam[i].value.toLowerCase().startsWith(alpha[context.currentAnswer] + ') ') ||
                exam[i].value.toLowerCase().startsWith(alpha[context.currentAnswer] + ' ')) {
                // Check if formatting screwed up.
                let possible_answer = exam[i].value;

                if (possible_answer.toLowerCase().includes(' ' + alpha[context.currentAnswer + 1] + '. ')) {
                    let parts = possible_answer.split(' ' + alpha[context.currentAnswer + 1] + '. ');
                    if (parts.length === 2) {
                        question.answers.push({ text: removeAlphanumericIndex(parts[0]), percent: percentValue});
                        question.answers.push({ text: parts[1], percent: 0}); // split() removed the index already.
                        context.currentAnswer = context.currentAnswer + 2;
                    }
                }
                else {
                    question.answers.push({text: removeAlphanumericIndex(exam[i].value), percent: percentValue});
                    exam[i].active = false;
                    question.tokens.push(exam[i].index);
                    context.currentAnswer++;
                }
            }
            // Questions aren't numbered... let's guess
            else if(exam[i].value.toLowerCase().startsWith(alpha[0] + '. ') ||
            exam[i].value.toLowerCase().startsWith(alpha[0] + ') ') ||
            exam[i].value.toLowerCase().startsWith(alpha[0] + ' ')) {
                let newValue = question.post.pop();
                if (question.answers.length === 0) {
                    question.type = 'shortanswer';
                }
                else if (question.answers.length === 2 && 
                    ( (question.answers[0].text.toLowerCase() === 'true' && question.answers[1].text.toLowerCase() === 'false') ||
                      (question.answers[0].text.toLowerCase() === 'false' && question.answers[1].text.toLowerCase() === 'true') )) {
                   question.type = 'truefalse';
                }
                else {
                    question.type = 'multichoice';
                }
                exam_final.questions.push(question);
                // reset
                context.currentAnswer = 0;
                question = {
                    selected: "#1e1e1e",
                    pre: [],
                    post: [],
                    type: '',
                    text: removeAlphanumericIndex(newValue),
                    answers: [],
                    tokens:[]
                }
                context.currentQuestion++;

                question.answers.push({text: removeAlphanumericIndex(exam[i].value), percent: percentValue});
                exam[i].active = false;
                question.tokens.push(exam[i].index);
                context.currentAnswer++;

            }
            else {
                question.post.push(exam[i].value);
                exam[i].active = false;
                question.tokens.push(exam[i].index);
            }
        }
    }

    if (context.state === LOOKING_FOR_ANSWERS) {
        if (question.answers.length === 0) {
            question.type = 'shortanswer';
        }
        else if (question.answers.length === 2 && 
            ( (question.answers[0].text.toLowerCase() === 'true' && question.answers[1].text.toLowerCase() === 'false') ||
              (question.answers[0].text.toLowerCase() === 'false' && question.answers[1].text.toLowerCase() === 'true') )) {
           question.type = 'truefalse';
        }
        else {
            question.type = 'multichoice';
        }
        exam_final.questions.push(question);
    }

    return {
        exam: exam_final,
        original: exam
    }
}

//assume no course, no categories specified for now

async function MoodleXMLFromQuiz(quizObj, qName, examId) {
    let output = '';
    // header
    output += '<?xml version="1.0" encoding="UTF-8"?>\n';
    output += '<quiz>\n';

    for (let qIndex = 0; qIndex < quizObj.questions.length; qIndex++) {
        // console.log('  Question ' + (qIndex + 1));
        output += await MoodleXMLFromQuestion(quizObj.questions[qIndex], qName, qIndex, examId);
    }

    // footer
    output += '</quiz>\n';

    return output;
}

function getAuth() {
    const idToken = Cookies.get('id_token');
    const options = {
        headers: {
            Authorization: idToken,
        }
    }

    return options;
}

//// Deal with:
//// <image> url of included image, and <image_base64>

// This function deals with tags common to all question types.
// General tags not handled yet:
// <tags><tag><text>keyword</text></tag>...</tags>
// <penalty>
// <generalfeedback>
// <defaultgrade>
// <hidden>
async function MoodleXMLFromQuestion(qObj, qName, index, examId) {
    let output = '';
    let qNumber = index + 1;
    qObj.type = NormaliseQuestionType(qObj);
    output += '  <question type="' + qObj.type + '">\n';
    output += '    <name>\n      <text>';
    if (!qName) {
        //    console.log('W: No name for question'); //// Add qnumber?
        qName = 'Question';
    }
    qObj.name = qName + '_' + qNumber;
    output += qObj.name + '</text>\n    </name>\n';
    // Are we going to use other formats??
    // html (default) | moodle_auto_format | plain_text | markdown
    output += '    <questiontext format="html">\n';
    if (!qObj.text) {
        console.log('W: No text for question'); //// Add qnumber?
        //qObj.text = qObj.name;
    }
    output += '      <text><![CDATA['
    if(qObj.pre.length > 0) {
        // combine array into string and wrap in P tags
        output += '<p>' + qObj.pre.join(' ') + '</p>';
    }
    output += '<p>' + qObj.text + '</p>'
    if(qObj.post.length > 0) {
        // combine array into string and wrap in P tags
        output += '<p>' + qObj.post.join(' ') + '</p>';
    }

    output += ']]></text>\n';

    // If there are any images, get the images and change the tags to link with the added base64 encoded image files.
    let imagesFound = false;
    let basedImageFiles = '';
    const regexp = /<img>([^<]*)<\/img>/g;
    const images = output.match(regexp);
    console.log(images);
    // Fetch images in base64, replace img and return
    if (images) {
        imagesFound = true;
        for (const image of images) {
            const basedImage = await axios.post('/api/images', { file: image, exam: examId }, getAuth());
            const imageName = image.replace('<img>images/','').replace('</img>', '');
            // Replace old img tag
            output = output.replace(image, `<img src="@@PLUGINFILE@@/${imageName}" alt="" class="img-responsive atto_image_button_text-bottom">`);
            // Add base64 image file
            basedImageFiles += `<file name="${imageName}" path="/" encoding="base64">${basedImage.data.image}</file>\n`;
        };
    }
    
    
    // If images found, append their base64 file below the </text> tag
    if (imagesFound) {
        output += basedImageFiles;
    }
    console.log(output);
    output += '    </questiontext>\n';

    // Call separate functions for question-type-specific tags.
    switch (qObj.type) {
        case 'multichoice':
            output += MoodleXMLFromQuestionMC(qObj);
            break;
        case 'truefalse':
            output += MoodleXMLFromQuestionTF(qObj);
            break;
        case 'shortanswer':
            output += MoodleXMLFromQuestionShortAnswer(qObj);
            break;
        case 'matching':
            console.error('E: Unhandled question type ' + qObj.type);
            break;
        case 'cloze':
            console.error('E: Unhandled question type ' + qObj.type);
            break;
        case 'essay':
            output += MoodleXMLFromQuestionEssay(qObj);
            break;
        case 'numerical':
            output += MoodleXMLFromQuestionNumerical(qObj);
            break;
        case 'description':
            //console.error('E: Unhandled question type ' + qObj.type);
            break;
        default:
            console.error('E: Unknown question type ' + qObj.type);
    }

    output += '  </question>\n';
    return output;
}

function MoodleXMLFromQuestionEssay(qObj) {
    let output = '';
    output += '    <answer fraction="0"><text></text></answer>\n';
    return output;
}

function MoodleXMLFromQuestionNumerical(qObj) {
    let output = '';
    if(qObj.answers.length > 0) {
        output += '    <answer fraction="100"><text>' + qObj.answers[0].text + '</text></answer>\n';
    }
    return output;
}

function MoodleXMLFromQuestionShortAnswer(qObj) {
    let output = '';
    if (typeof (qObj.casesensitive) != 'undefined') {
        switch (qObj.casesensitive) {
            case true:
            case 1:
            case 'true':
            case 'True':
            case 'TRUE':
                output += '    <usecase>1</usecase>\n';
        }
    }
    if (!qObj.answers) {
        console.error('E: No answers in short answer question.');
        return '';
    }
    for (let a = 0; a < qObj.answers.length; a++) {
        output += '    <answer fraction="100">';
        if (typeof (qObj.answers[a].text) != 'undefined') {
            output += '      <text>' + qObj.answers[a].text + '</text>\n';
        } else {
            console.error('E: No text for Short Answer ' + a);
        }
        // Have not dealt with:
        // <feedback>
        output += '    </answer>';
    }
    return output;
}

function MoodleXMLFromQuestionTF(qObj) {
    let output = '';
    if (!qObj.answers) {
        console.error('E: No answers in True/False question.');
        return '';
    }
    if (!Array.isArray(qObj.answers) || (qObj.answers.length != 2)) {
        console.error('E: True/False questions require 2 answers.');
        return '';
    }
    for (let a = 0; a < qObj.answers.length; a++) {
        output += '    <answer';
        if (typeof (qObj.answers[a].percent) != 'undefined') {
            output += ' fraction="' + qObj.answers[a].percent.toString() + '"';
        } else {
            output += ' fraction="0"';
        }
        output += ' format="moodle_auto_format">\n';
        if (typeof (qObj.answers[a].text) != 'undefined') {
            output += '      <text>' + qObj.answers[a].text.toLowerCase() + '</text>\n';
        } else {
            output += '      <text>false</text>\n';
            console.error('W: Assuming T/F answer [' + a + '] without text is False');
        }
        output += '    </answer>\n';
    }
    return output;
}

function MoodleXMLFromQuestionMC(qObj) {
    let output = '';
    if (!qObj.answers) {
        console.error('E: No answers in multiple choice question.');
        return '';
    }
    if (!Array.isArray(qObj.answers)) {
        console.error('E: Multiple Choice Questions require array of answers.');
        return '';
    }
    for (let a = 0; a < qObj.answers.length; a++) {
        output += '    <answer';
        if (typeof (qObj.answers[a].percent) != 'undefined') {
            output += ' fraction="' + qObj.answers[a].percent.toString() + '"';
        } else {
            output += ' fraction="0"';
        }
        output += ' format="html">\n';
        if (typeof (qObj.answers[a].text) != 'undefined') {
            output += '      <text><![CDATA[' + qObj.answers[a].text + ']]></text>\n';
        } else {
            console.error('E: No text for Multiple Choice Answer ' + a);
        }
        output += '    </answer>\n';
    }
    // MC properties that apply to whole question.
    if ((typeof (qObj.shuffle) != 'undefined') && qObj.shuffle) {
       output += '    <shuffleanswers>1</shuffleanswers>\n';
    } else {
       output += '    <shuffleanswers>0</shuffleanswers>\n';
    }
    if ((typeof (qObj.multipleanswers) != 'undefined') && qObj.multipleanswers) {
        output += '    <single>false</single>\n';
    } else {
        output += '    <single>true</single>\n';
    }

    // Numbering possibilities: (none/abc/ABCD/123)
    //output += '      <answernumbering>abc</answernumbering>\n';

    // Have not dealt with:
    // <feedback>
    // <correctfeedback>
    // <partiallycorrectfeedback>
    // <incorrectfeedback>

    return output;
}

// Return one of the known Moodle XML question types.
function NormaliseQuestionType(qObj) {
    if (typeof (qObj.type) != 'string') {
        qObj.type = qObj.type.toString();
    }
    switch (qObj.type.toLowerCase()) {
        //    case '':
        case 'mc':
        case 'MC':
        case 'multiplechoice':
        case 'multiple choice':
        case 'multichoice':
            return 'multichoice';
        case 'tf':
        case 'TF':
        case 'true false':
        case 'true or false':
        case 'true and false':
        case 'true & false':
        case 'true/false':
        case 'true-false':
        case 'truefalse':
            return 'truefalse';
        case 'sa':
        case 'shortanswer':
        case 'short answer':
            return 'shortanswer';
        case 'match':
        case 'matching':
            return 'matching';
        case 'cloze':
            return 'cloze';
        case 'essay':
            return 'essay';
        case 'numeric':
        case 'numerical':
            return 'numerical';
        case 'description':
            return 'description';
        default:
            // Could we guess based on other question fields??
            console.error('E: Unknown question type ' + qObj.type);
    }
    return 'description';
}

export {
    decodeUser,
    autoGenerateExam,
    MoodleXMLFromQuiz
};